export function _e(t) {
	return t;
}
export const fieldHeight = 37;

const primaryColor = '#215bab';
const primaryHoverColor = '#0b2f80';
const primaryTextColor = '#FFF';
const darkBlueTextColor = '#1b4888';
const secondaryColor = '#66a2ff';
const secondaryHoverColor = '#d0021b';
const jointColor = '#578b29';
const alternateColor = '#005e99';
const textColorLightTheme = '#454545';
const helpColor = '#74a342';
const newFeatureColor = '#00d8a6';
const defaultInputBorderColor = 'rgba(0, 0, 0, 0.23)';
// const textColorLightTheme = '#17375b';

const captionColorDarkTheme = '#AAA';
const captionColorLightTheme = '#CCC';
const iconBackgroundColor = '#ece8ef';
const tertiaryColor = '#666';
const warningColor = '#FEA22D';
const contrastColor = '#C8425D';
const contrastColorHover = '#d12852';
const borderColor = '#d6d6d6';
// const secondaryIconColor = '#AABFD8';
const secondaryIconColor = '#648cc4';
const dropdownBtnBgColor = '#d9e2ed';
const headerBackgroundColor = '#f3f3f3';
const lightBackground = '#91919114';
const selectedTabStyleTextColor = '#0b2f80';

const pieColors = [
	'#a6cee3',
	'#1f78b4',
	'#b2df8a',
	'#33a02c',
	'#fb9a99',
	'#e31a1c',
	'#fdbf6f',
	'#ff7f00',
	'#cab2d6',
	'#6a3d9a',
	'#ffff99',
	'#b15928'
];

const darkColors = ['#1f78b4', '#e31a1c', '#6a3d9a', '#33a02c', '#ff7f00'];
const pieColors2 = [
	'#8dd3c7',
	'#ffffb3',
	'#bebada',
	'#fb8072',
	'#80b1d3',
	'#fdb462',
	'#b3de69',
	'#fccde5',
	'#d9d9d9',
	'#bc80bd',
	'#ccebc5',
	'#ffed6f'
];

const investmentIncomeColor = '#ccebc5';
const investmentPaymentColor = '#fb8072';
const investmentColorArray = [
	'#081d58',
	'#253494',
	'#225ea8',
	'#1d91c0',
	'#41b6c4',
	'#7fcdbb',
	'#c7e9b4',
	'#edf8b1',
	'#ffffd9'
];

const gmChartColorArray = ['#e13a0e', '#e8aa10', '#0099cc', '#64cc21', '#000051'];

const colorArray = [
	'#a6cee3',
	'#1f78b4',
	'#b2df8a',
	'#33a02c',
	'#fb9a99',
	'#e31a1c',
	'#fdbf6f',
	'#ff7f00',
	'#cab2d6',
	'#6a3d9a',
	'#ffff99',
	'#b15928'
];

const chartColorArray = [
	'#a6cee3',
	'#1f78b4',
	'#b2df8a',
	'#33a02c',
	'#fb9a99',
	'#e31a1c',
	'#fdbf6f',
	'#ff7f00',
	'#cab2d6',
	'#6a3d9a',
	'#ffff99',
	'#b15928'
];

const cardColors = ['#56D9FE', '#FFDA83', '#FD8D7F', '#5FE3A1', '#A5C9FF', '#174A84'];

const cardFontColors = ['#109CFC', '#FF9F29', '#FA3026', '#13B344', '#497EFF', '#56D9FE'];

export const colors = {
	newFeatureColor,
	investmentIncomeColor,
	investmentPaymentColor,
	investmentColorArray,
	pieColors,
	pieColors2,
	helpColor,
	jointColor,
	colorArray,
	defaultInputBorderColor,
	borderColor,
	contrastColor,
	errorColor: secondaryHoverColor,
	contrastColorHover,
	brandColor: primaryColor,
	brandColorHover: primaryHoverColor,
	secondaryColor,
	warningColor,
	iconColor: '#888',
	defaultTextColor: textColorLightTheme,
	secondaryTextColor: primaryTextColor,
	alternateColor,
	tertiaryColor,
	secondaryIconColor,
	captionColorDark: captionColorDarkTheme,
	captionColor: captionColorLightTheme,
	iconBackgroundColor,
	dropdownBtnBgColor,
	headerBackgroundColor,
	lightBackground,
	gmChartColorArray,
	chartColorArray,
	darkBlueTextColor,
	cardColors,
	cardFontColors,
	selectedTabStyleTextColor,
	darkColors
};

export const dataURLToBlob = dataURL => {
	if (typeof window !== 'undefined') {
		const BASE64_MARKER = ';base64,';
		if (dataURL.indexOf(BASE64_MARKER) === -1) {
			const parts = dataURL.split(',');
			const contentType = parts[0].split(':')[1];
			const raw = parts[1];
			return new Blob([raw], { type: contentType });
		}

		const parts = dataURL.split(BASE64_MARKER);
		const contentType = parts[0].split(':')[1];
		const raw = window.atob(parts[1]);
		const rawLength = raw.length;
		const uInt8Array = new Uint8Array(rawLength);

		for (let i = 0; i < rawLength; i += 1) {
			uInt8Array[i] = raw.charCodeAt(i);
		}
		return new Blob([uInt8Array], { type: contentType });
	}
	return undefined;
};
